// loader.decorator.ts
import { LoaderService } from '@elan/services/loader-service';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

export function WithLoader() {
  return function (
    target: any,
    propertyKey: string,
    descriptor: PropertyDescriptor
  ) {
    const originalMethod = descriptor.value;

    descriptor.value = function (...args: any[]): Observable<any> {
      const self = this as { loaderService: LoaderService };

      if (!self.loaderService) {
        throw new Error(
          `LoaderService not found. Please inject it in ${target.constructor.name}`
        );
      }

      // first argument can be string | string[]
      const loaderArg = args[0];
      if (!loaderArg) {
        throw new Error(
          `Missing loaderId(s) in function call: ${propertyKey}`
        );
      }

      const loaderIds = Array.isArray(loaderArg) ? loaderArg : [loaderArg];
      

      // show loader(s) before method call
      loaderIds.forEach((id) => self.loaderService.show(id));

      // call the original method (it should return an Observable)
      const result: Observable<any> = originalMethod.apply(this, args);

      if (!(result instanceof Observable)) {
        throw new Error(
          `@WithLoader can only be applied to methods returning Observables`
        );
      }

      // hide loader(s) after completion (success or error)
      return result.pipe(
        finalize(() => {
          loaderIds.forEach((id) => self.loaderService.hide(id));
        })
      );
    };

    return descriptor;
  };
}
